import { ResponsiveContainer, FunnelChart as RechartsFunnelChart, Funnel, Cell, Tooltip, LabelList } from 'recharts';
import { tokens } from '@fluentui/react-components';

/**
 * FunnelChart — embudo genérico de una sola serie (magnitud), pensado para
 * la curva de rendimiento acumulado (`yieldCurvePct`) por etapa. Un solo
 * matiz de marca, claro→oscuro por etapa (secuencial), nunca arcoíris.
 */
export interface FunnelStageDatum {
  name: string;
  value: number;
}

interface FunnelChartProps {
  data: FunnelStageDatum[];
  height?: number;
  valueFormatter?: (value: number) => string;
}

export function FunnelChart({ data, height = 280, valueFormatter }: FunnelChartProps) {
  if (data.length === 0) return null;
  const fmt = valueFormatter ?? ((v: number) => `${v.toFixed(0)}%`);
  const n = Math.max(data.length - 1, 1);

  return (
    <ResponsiveContainer width="100%" height={height}>
      <RechartsFunnelChart>
        <Tooltip formatter={(value: number) => fmt(value)} />
        <Funnel dataKey="value" data={data} isAnimationActive={false}>
          <LabelList dataKey="name" position="right" fill={tokens.colorNeutralForeground1} stroke="none" />
          <LabelList dataKey="value" position="center" formatter={fmt} fill={tokens.colorNeutralForegroundOnBrand} stroke="none" />
          {data.map((_, i) => (
            <Cell key={`cell-${i}`} fill={tokens.colorBrandBackground} fillOpacity={0.35 + (0.65 * i) / n} />
          ))}
        </Funnel>
      </RechartsFunnelChart>
    </ResponsiveContainer>
  );
}
